import { GridRowHeightReturnValue } from '@mui/x-data-grid';
import { CSSProperties } from 'react';

export const TABLE_LINK_STYLE: CSSProperties = {
  textDecoration: 'none',
  color: 'rgba(0, 0, 0, 0.87)',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis',
};

export const TABLE_LINK_STYLE_FOR_TEMPLATE: CSSProperties = {
  ...TABLE_LINK_STYLE,
  textAlign: 'left',
};

export const TABLE_ROW_HEIGHT = 52;

export const EXPANDED_TABLE_PROPERTIES = {
  autoTableHeight: true,
  getRowHeight: () => 'auto' as unknown as GridRowHeightReturnValue,
  getEstimatedRowHeight: () => TABLE_ROW_HEIGHT,
  sx: {
    '.MuiDataGrid-cell': { minHeight: `${TABLE_ROW_HEIGHT}px` },
    '.MuiAccordionSummary-content': { margin: 0 },
    '.latestNotes': {
      paddingTop: '0px !important',
      paddingBottom: '0px !important',
    },
    '.collapsible': {
      paddingTop: '0px !important',
      paddingBottom: '0px !important',
    },
  },
};
